import { version, commit } from "./version";

import { IEnvironment } from "@aa/common";

export const environment: IEnvironment = {
  production: true,
  version: version,
  commit: commit,
  selfServDomain: undefined, // injected into window.appConfig
};
